export const DB_NAME = `${process.env.MULTIBOOK_TYPE}`;
export const AUDIO_NAMES = [
  // '/static/media/dev/audio/test/test.mp3'
];
export const VIDEO_NAMES = [
  // "/static/media/dev/films/page019/Earth's_Axis.mp4",
  // '/static/media/dev/films/page008/008 sem2_tab38_tranzyt wenus.mp4',
  // '/static/media/dev/films/page008/NASA_Rozbłysk na Słoncu.mp4',
  // '/static/media/dev/films/page008/008 Uklad Sloneczny shutterstock 1006650247.mp4',
  // '/static/media/dev/films/page016/Dateline_animation_3deg.mp4',
  // '/static/media/dev/films/page010/Asteroid_2004_FH_1.mp4',
  // '/static/media/dev/films/page010/010 sem2_tab38_ewolucja ksiezyca.mp4',
  // '/static/media/dev/films/page006/006_spiralna_film.mp4',
  // "/static/media/dev/films/page019/Earth's_Axis.mp4",
  // '/static/media/dev/films/page008/008 sem2_tab38_tranzyt wenus.mp4',
  // '/static/media/dev/films/page008/NASA_Rozbłysk na Słoncu.mp4',
  // '/static/media/dev/films/page008/008 Uklad Sloneczny shutterstock 1006650247.mp4',
  // '/static/media/dev/films/page016/Dateline_animation_3deg.mp4',
  // '/static/media/dev/films/page010/Asteroid_2004_FH_1.mp4',
  // '/static/media/dev/films/page010/010 sem2_tab38_ewolucja ksiezyca.mp4',
  // '/static/media/dev/films/page006/006_spiralna_film.mp4',
];
